<template>
	<div
		class="empty-state"
		:class="{ 'empty-state--bordered': bordered }"
	>
		<div class="empty-state__intro">
			<slot name="icon">
				<div
					class="empty-state__icon"
					:style="iconMaskStyle"
				/>
			</slot>
			<span
				v-if="header"
				class="sgnl-text-center sgnl-subtitle-medium sgnl-text-color-default"
				>{{ header }}</span
			>
			<span
				v-if="body"
				class="sgnl-text-center sgnl-paragraph-s-regular sgnl-text-color-secondary"
				>{{ body }}</span
			>
		</div>
		<div
			v-if="$slots.actions"
			class="empty-state__actions"
		>
			<slot name="actions" />
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import searchLocateIcon from "@/assets/icons/repositories/search-locate-32.svg";

export default defineComponent({
	name: "EmptyState",
	props: {
		header: { type: String, default: undefined },
		body: { type: String, default: undefined },
		icon: { type: String, default: searchLocateIcon },
		bordered: { type: Boolean, default: false },
	},
	computed: {
		iconMaskStyle(): Record<string, string> {
			return { "--empty-state-mask": `url("${this.icon}")` };
		},
	},
});
</script>

<style lang="scss" scoped>
.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--sgnl-space-16);
	padding: var(--sgnl-space-48) var(--sgnl-space-16);
}

.empty-state--bordered {
	border: var(--sgnl-border-width-1) solid var(--sgnl-default-primary-border);
	border-radius: var(--sgnl-border-radius-6);
}

.empty-state__intro {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--sgnl-space-8);
}

.empty-state__icon {
	width: var(--sgnl-icon-48);
	height: var(--sgnl-icon-48);
	background-color: var(--sgnl-default-tertiary-icon);
	-webkit-mask-image: var(--empty-state-mask);
	mask-image: var(--empty-state-mask);
	-webkit-mask-size: contain;
	mask-size: contain;
	-webkit-mask-repeat: no-repeat;
	mask-repeat: no-repeat;
	-webkit-mask-position: center;
	mask-position: center;
}

.empty-state__actions {
	display: flex;
	gap: var(--sgnl-space-8);
}

@media (max-width: 599px) {
	.empty-state__actions {
		width: 100%;
	}
}
</style>
